import TipsSection from './TipsSection';

export default TipsSection;
